import Vue from 'vue';
import Vuex from 'vuex';
import modules from './Modules/moduleLoader';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: modules
})



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/mainstore.js